import { render, staticRenderFns } from "./ExamExceptionCreate.vue?vue&type=template&id=5797f270&scoped=true"
import script from "./ExamExceptionCreate.vue?vue&type=script&lang=js"
export * from "./ExamExceptionCreate.vue?vue&type=script&lang=js"
import style0 from "./ExamExceptionCreate.vue?vue&type=style&index=0&id=5797f270&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5797f270",
  null
  
)

export default component.exports